/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzsherr7Inputs */

const en__field_enum_mzsherr7 = /** @type {(inputs: _Field_Enum_Mzsherr7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mr.`)
};

const de__field_enum_mzsherr7 = /** @type {(inputs: _Field_Enum_Mzsherr7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herr`)
};

/**
* | output |
* | --- |
* | "Mr." |
*
* @param {_Field_Enum_Mzsherr7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzsherr7 = /** @type {((inputs?: _Field_Enum_Mzsherr7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzsherr7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzsherr7(inputs)
	return de__field_enum_mzsherr7(inputs)
});
export { _field_enum_mzsherr7 as "_field_enum_MZSHERR" }